import React from 'react';
import _classes from './BidHistory.module.css';
import dayjs from 'dayjs';
import link from '../../assets/icons/Link.svg';
import { buildEtherscanTxLink } from '../../utils/etherscan';
import TruncatedAmount from '../TruncatedAmount';
import { Bid } from '../../utils/types';
import { useAuctionBids } from '../../wrappers/onDisplayAuction';
import { useAppSelector } from '../../hooks';
import { Name } from '@coinbase/onchainkit';

const bidItem = (bid: Bid, index: number, classes: any, isCool?: boolean) => {
  const bidAmount = <TruncatedAmount amount={bid.value} />;
  const date = `${dayjs(Number(bid.timestamp) * 1000).format('MMM DD')} at ${dayjs(
    Number(bid.timestamp) * 1000
  ).format('hh:mm a')}`;

  const txLink = buildEtherscanTxLink(bid.transactionHash);

  return (
    <li key={index} className={classes.bidRowCool}>
      <div className={classes.bidItem}>
        <div className={classes.leftSectionWrapper}>
          <div className={classes.bidder}>
            <div>
              <Name address={bid.sender} className='uppercase' />
            </div>
          </div>
          <div className={classes.bidDate}>{date}</div>
        </div>
        <div className={classes.rightSectionWrapper}>
          <div className={classes.bidAmount}>Ξ {bidAmount}</div>
          <div className={classes.linkSymbol}>
            <a href={txLink} target='_blank' rel='noreferrer'>
              <img src={link} width={24} alt='link symbol' />
            </a>
          </div>
        </div>
      </div>
    </li>
  );
};

const BidHistory: React.FC<{
  auctionId: bigint;
  max: number;
  classes?: any;
}> = (props) => {
  const { auctionId, max, classes = _classes } = props;
  const isCool = useAppSelector((state) => state.application.isCoolBackground);
  const bids = useAuctionBids(auctionId);
  const bidContent =
    bids &&
    bids
      .map((bid: Bid, i: number) => {
        return bidItem(bid, i, classes, isCool);
      })
      .slice(0, max);

  return <ul className={classes.bidCollection}>{bidContent}</ul>;
};

export default BidHistory;
